var render, staticRenderFns
import script from "./LucideIcon.vue?vue&type=script&lang=js"
export * from "./LucideIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/appdata/www/radzs_testing/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('32a83260')) {
      api.createRecord('32a83260', component.options)
    } else {
      api.reload('32a83260', component.options)
    }
    
  }
}
component.options.__file = "resources/js/frontend/components/common/atoms/LucideIcon.vue"
export default component.exports